/* eslint-disable sort-keys */
export function getStateAbbr(value: string | undefined): string | undefined {
  const states: any = {
    alabama: 'AL',
    alaska: 'AK',
    arizona: 'AZ',
    arkansas: 'AR',
    california: 'CA',
    colorado: 'CO',
    connecticut: 'CT',
    delaware: 'DE',
    'district of columbia': 'DC',
    florida: 'FL',
    georgia: 'GA',
    hawaii: 'HI',
    idaho: 'ID',
    illinois: 'IL',
    indiana: 'IN',
    iowa: 'IA',
    kansas: 'KS',
    kentucky: 'KY',
    louisiana: 'LA',
    maine: 'ME',
    maryland: 'MD',
    massachusetts: 'MA',
    michigan: 'MI',
    minnesota: 'MN',
    mississippi: 'MS',
    missouri: 'MO',
    montana: 'MT',
    nebraska: 'NE',
    nevada: 'NV',
    'new hampshire': 'NH',
    'new jersey': 'NJ',
    'new mexico': 'NM',
    'new york': 'NY',
    'north carolina': 'NC',
    'north dakota': 'ND',
    ohio: 'OH',
    oklahoma: 'OK',
    oregon: 'OR',
    pennsylvania: 'PA',
    'rhode island': 'RI',
    'south carolina': 'SC',
    'south dakota': 'SD',
    tennessee: 'TN',
    texas: 'TX',
    utah: 'UT',
    vermont: 'VT',
    virginia: 'VA',
    washington: 'WA',
    'west virginia': 'WV',
    wisconsin: 'WI',
    wyoming: 'WY',
    alberta: 'AB',
    'british columbia': 'BC',
    manitoba: 'MB',
    'new brunswick': 'NB',
    'newfoundland and labrador': 'NL',
    'northwest territories': 'NT',
    'nova scotia': 'NS',
    nunavut: 'NU',
    ontario: 'ON',
    'prince edward island': 'PE',
    quebec: 'QC',
    saskatchewan: 'SK',
    yukon: 'YT',
    aguascalientes: 'AG',
    'baja california norte': 'BN',
    'baja california sur': 'BS',
    coahuila: 'CH',
    chihuahua: 'CI',
    colima: 'CL',
    campeche: 'CP',
    chiapas: 'CS',
    'districto federal': 'DF',
    durango: 'DG',
    guerrero: 'GE',
    guanajuato: 'GJ',
    hidalgo: 'HD',
    jalisco: 'JA',
    michoacan: 'MC',
    morelos: 'MR',
    mexico: 'MX',
    nayarit: 'NA',
    'nuevo leon': 'NL',
    oaxaca: 'OA',
    puebla: 'PU',
    queretaro: 'QE',
    'quintana roo': 'QI',
    sinaloa: 'SI',
    'san luis potosi': 'SL',
    sonora: 'SO',
    tamaulipas: 'TA',
    tabasco: 'TB',
    tlaxcala: 'TL',
    veracruz: 'VC',
    yucatan: 'YU',
    zacatecas: 'ZA',
  };
  if (value && value.length > 2) {
    return states[value.toLowerCase()] ?? value;
  }
  return value;
}
